/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
/*
*/
import { prefix, b58cdecode } from '@taquito/utils';
import sodium from 'sodium-javascript';
// import bs58check from 'bs58check';
import { Key } from 'sotez';
import blake2b from 'blake2b';

import axios from 'axios';
import { FirebaseUser } from '~/types';

// export const b58decode = (enc, pre) => bs58check.decode(enc).slice(pre.length);

export const stringToBytes = (s: string): Buffer => Buffer.from(s, 'utf8');

export const messageToBytes = (message: string) => {
  // The data to format
  // const dappUrl = 'hic.af';
  // const ISO8601formatedTimestamp = new Date().toISOString();

  // The full string
  // Tezos Signed Message: Confirming my identity as tz1Ks8hgrG2qfj7ZWREcLxSKUQBJcBqnrRSr on objkt.com at 2021-10-28T07:33:47.122Z
  const formattedInput: string = [
    'Tezos Signed Message:',
    // dappUrl,
    // ISO8601formatedTimestamp,
    message,
  ].join(' ');
  return stringEncoder(formattedInput);
  /*
  // The bytes to sign
  const bytes = char2Bytes(formattedInput);
  const payloadBytes = `0501${char2Bytes(`${bytes.length}`)}${bytes}`;
  return payloadBytes;
  */
};

export const stringEncoder = (s: string): string => {
  const bytes = Buffer.from(s, 'utf8');
  return `0501${toPaddedHex(bytes.length)}${bytes.toString('hex')}`;
};

const toPaddedHex = (n: number, padLen: number = 8, padChar: string = '0'): string => n.toString(16).padStart(padLen, padChar);

export const getUserByAddress = async (publicAddress: string): Promise<FirebaseUser> => {
  const { data: users } = await axios.get<FirebaseUser[]>('/api/users', { params: { publicAddress } });
  let user = users?.[0];
  console.log('Signup: initial user with address.', publicAddress, user);
  if (!user) {
    const { data } = await axios.post<{ user: FirebaseUser }>('/api/users', { publicAddress });
    user = data.user;
    console.log('Signup: created user with address.', publicAddress, user);
  }
  return user;
};

export const getMessageFromNonce = (nonce: number): string => `Please sign this message to authenticate with HIC.AF. ${nonce}`;
export const getSignatureBytesFromNonce = (nonce: number) => messageToBytes(getMessageFromNonce(nonce));

export const getAddressFromPublicKey = async (publicKey: string): Promise<string> => {
  const sotezKey = new Key({ key: publicKey });
  await sotezKey.ready;
  return sotezKey.publicKeyHash();
};

export const hex2buf = (hex) => new Uint8Array(
  hex.match(/[\da-f]{2}/gi).map((h) => parseInt(h, 16)),
);

export const verifySignature = async ({
  bytes,
  signature,
  publicKey,
}) => {
  console.log('Verifying signature...', {
    bytes,
    signature,
    publicKey,
  });
  try {
    const verify = sodium.crypto_sign_verify_detached(
      b58cdecode(signature, prefix.edsig),
      blake2b(32, bytes),
      b58cdecode(publicKey, prefix.edpk),
    );
    return verify;
  } catch (e) {
    console.log('Error: ', e);
    throw e;
  }
};
